import { TeachersTable } from '../../../../components/Lessons/Tables/Teachers/TeachersTable';
import { Page } from '../../../../components/Page/Page';
import { usePermissionChecker } from '../../../../hooks/usePermissionChecker';

export const LessonTeachersSubpage = () => {
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canReadDeputate()}>
      <TeachersTable />
    </Page>
  );
};
